import { Dialog, Transition } from "@headlessui/react";
import cx from "classnames";
import { Fragment } from "react";

import { Button, Heading, List } from "@icg360/design-system";

import styles from "./ss1.module.scss";

type SageSureOneModalProps = {
  open: boolean;
  onClose?: () => void;
};

export const SageSureOneModal = ({ open, onClose }: SageSureOneModalProps) => {
  const handleClose = onClose ?? (() => {});

  return (
    <Transition show={open} as={Fragment}>
      <Dialog onClose={handleClose} className={styles.dialog}>
        <Transition.Child
          as={Fragment}
          enter={styles.backdropEnter}
          enterFrom={styles.backdropHidden}
          enterTo={styles.backdropVisible}
          leave={styles.backdropLeave}
          leaveFrom={styles.backdropVisible}
          leaveTo={styles.backdropHidden}
        >
          <div className={styles.backdrop} aria-hidden="true" />
        </Transition.Child>

        <div className={styles.container}>
          <Transition.Child
            as={Fragment}
            enter={styles.panelEnter}
            enterFrom={styles.panelHidden}
            enterTo={styles.panelVisible}
            leave={styles.panelLeave}
            leaveFrom={styles.panelVisible}
            leaveTo={styles.panelHidden}
          >
            <Dialog.Panel className={styles.panel}>
              <header className={styles.modalHeader}>
                <img
                  className={styles.logo}
                  src="/assets/images/ss1-one.svg"
                  alt="SageSure One"
                />
                <Button
                  icon="Close"
                  size="sm"
                  appearance="tertiary"
                  onClick={handleClose}
                />
              </header>
              <section className={styles.modalHero}>
                <Dialog.Title as={Heading} size="sm">
                  Your policy includes SageSure One
                </Dialog.Title>
                <p className="body-lg-regular">
                  This experience gives you the guidance to protect your home
                  and strengthen its resilience for the long term.
                </p>
              </section>
              <List type="icon">
                <List.Item iconName="ModernHome">
                  <p className={cx("body-md-medium", styles.listHead)}>
                    Home value insights
                  </p>
                  <p className={cx("body-sm-regular", styles.listDesc)}>
                    We'll assess your home's characteristics and replacement
                    cost so you always have an up-to-date picture of what you're
                    protecting.
                  </p>
                </List.Item>
                <List.Item iconName="SearchSpark">
                  <p className={cx("body-md-medium", styles.listHead)}>
                    Home resilience advisory
                  </p>
                  <p className={cx("body-sm-regular", styles.listDesc)}>
                    We'll connect you with services and recommendations to help
                    strengthen your home and protect the life you've built.
                  </p>
                </List.Item>
                <List.Item iconName="Lightbulb">
                  <p className={cx("body-md-medium", styles.listHead)}>
                    Specialized claims support
                  </p>
                  <p className={cx("body-sm-regular", styles.listDesc)}>
                    If you ever experience a loss, you'll work with specialized
                    claims professionals who understand unique homes and what it
                    takes to restore them.
                  </p>
                </List.Item>
                <List.Item iconName="PersonWithMessage">
                  <p className={cx("body-md-medium", styles.listHead)}>
                    Dedicated SageSure One consultant
                  </p>
                  <p className={cx("body-sm-regular", styles.listDesc)}>
                    Your One Consultant is your personal contact at SageSure who
                    can answer your questions and provide specialized support
                    through the life of your policy.
                  </p>
                </List.Item>
              </List>
              <footer className={styles.modalFooter}>
                <Button
                  appearance="secondary"
                  inverse
                  onClick={() => {
                    // TODO: open FAQs
                  }}
                  className={styles.faqBtn}
                >
                  View FAQs
                </Button>
                <Button
                  appearance="primary"
                  inverse
                  onClick={handleClose}
                  className={styles.closeBtn}
                >
                  Close
                </Button>
              </footer>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};
